import { Modal, Button, Spinner } from "react-bootstrap";
import { useState, useEffect } from "react";

interface Props {
  show: boolean;
  onHide: () => void;
  pdfUrl: string | null;
  title?: string;
}

export const PDFPreviewModal = ({ show, onHide, pdfUrl, title = "Vista previa PDF" }: Props) => {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (pdfUrl) {
      setLoading(true);
    }
  }, [pdfUrl]);

  const handleDownload = () => {
    if (pdfUrl) {
      const link = document.createElement('a');
      link.href = pdfUrl;
      link.download = `${title.replace(/\s+/g, '_')}.pdf`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  };

  return (
    <Modal show={show} onHide={onHide} size="xl" centered>
      <Modal.Header closeButton>
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body style={{ padding: 0, height: "80vh" }}>
        {loading && (
          <div className="d-flex justify-content-center align-items-center" style={{ height: "100%" }}>
            <Spinner animation="border" variant="primary" />
            <span className="ms-2">Cargando PDF...</span>
          </div>
        )}
        {pdfUrl && (
          <iframe
            src={pdfUrl}
            style={{
              width: "100%",
              height: "100%",
              border: "none",
              display: loading ? "none" : "block"
            }}
            onLoad={() => setLoading(false)}
            title="Vista previa PDF"
          />
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="success" onClick={handleDownload} disabled={!pdfUrl}>
          Descargar PDF
        </Button>
        <Button variant="secondary" onClick={onHide}>
          Cerrar
        </Button>
      </Modal.Footer>
    </Modal>
  );
};
